import api from '@/api'

const state = {
}

const mutations = {
}

const actions = {
  // 获取软件列表
  async getSoftwareList ({commit, state}, payload) {
    const {data} = await api.deployApi.getSoftware(payload)
    return data
  },
  // 获取软件配置列表
  async getSoftwareConfigList ({commit, state}, payload) {
    const {data} = await api.deployApi.getSoftwareConfig(payload)
    return data
  },
  // 获取依赖配置列表
  async getCgDependenceConfigList ({commit, state}, payload) {
    const {data} = await api.deployApi.getCgDependenceConfigList(payload)
    return data
  },
  // 编辑软件配置状态
  async editCgVersionConfigStatus ({commit, state}, payload) {
    const {data, code} = await api.deployApi.editCgVersionConfigStatus(payload)
    return {data, code}
  },
  // 新增软件
  async addSoftware ({commit, state}, payload) {
    const {code, message} = await api.deployApi.addSoftware(payload)
    return {code, message}
  },
  // 新增自定义软件
  async addCustomizeCgVersion ({commit, state}, payload) {
    const {code, message} = await api.deployApi.addCustomizeCgVersion(payload)
    return {code, message}
  },
  // 新增软件配置
  async addSoftwareConfig ({commit, state}, payload) {
    const {code, message} = await api.deployApi.addSoftwareConfig(payload)
    return {code, message}
  },
  // 编辑软件
  async editSoftware ({commit, state}, payload) {
    const {code, message} = await api.deployApi.editSoftware(payload)
    return {code, message}
  },
  // 编辑自定义提交软件
  async editCustomizeCgVersion ({commit, state}, payload) {
    const {code, message} = await api.deployApi.editCustomizeCgVersion(payload)
    return {code, message}
  },
  // 删除软件
  async deleteSoftware ({commit, state}, payload) {
    const code = await api.deployApi.deleteSoftware(payload)
    return code
  },
  // 删除软件配置
  async deleteSoftwareConfig ({commit, state}, payload) {
    const code = await api.deployApi.deleteSoftwareConfig(payload)
    return code
  },
  // 查询是否有关联插件
  async queryIsHaveCgPlugin ({state}, payload) {
    const {data} = await api.deployApi.queryIsHaveCgPlugin(payload)
    return data
  },
  // 给软件版本分配支持的平台
  async allocatePlatform ({state}, payload) {
    const {code} = await api.deployApi.allocatePlatform(payload)
    return code
  },
  // 给软件版本分配支持的系统
  async allocateOS ({state}, payload) {
    const {code} = await api.deployApi.allocateOS(payload)
    return code
  },
  // 软件的下拉框列表
  async getCgVersionControlPullSelect ({state}, payload) {
    const {data} = await api.deployApi.getCgVersionControlPullSelect(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
